import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CERTIFICADOS } from '@env';

@Injectable()
export class CertificacionProvider {

  constructor(public http: HttpClient) {
  }

  get(liderEntrenamiento: string ): Promise<any> {
    return this.http.get(`${CERTIFICADOS.GET}${liderEntrenamiento}` ).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/certificacion/certificacion.ts